import { Link } from "react-router-dom";
import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import SEOHead from "../components/shared/SEOHead";
import { Home, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const NotFoundPage = () => (
  <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
    <SEOHead
      title="Page Not Found | Hitech Transit"
      description="The page you're looking for doesn't exist. Return to Hitech Transit homepage for removal services in Cardiff and South Wales."
      noindex={true}
    />
    <Header />
    <main className="flex-1 flex items-center justify-center px-4 py-20">
      <div className="text-center max-w-md">
        <div className="text-8xl font-['Outfit'] font-black text-[#0F172A] mb-2">404</div>
        <h1 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mb-3">
          Page not found
        </h1>
        <p className="text-slate-500 mb-8 text-sm leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="btn-primary h-11">
            <Link to="/" data-testid="404-home-btn">
              <Home className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </Button>
          <Button asChild variant="outline" className="h-11">
            <Link to="/instant-quote" data-testid="404-quote-btn">
              Get a Free Quote
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default NotFoundPage;
